<template>
<div class="content">
  <q-card>
    <q-card-title>
      {{$t('global.EnterNewOrders')}} 
      <div class="col-12">
          <span v-if="false">{{$t('global.GeoRegions')}} <q-toggle v-model="byProduct" :label="$t('global.Product')" /></span>
          <q-select
            v-model="idProduct"
            :float-label="$t('global.Product')"
            :options="optionsProduct"  
            ref="selProducts" 
          />  
        </div>
      <div>
        <span v-if="!byProduct">
          <span>{{$t('global.GeoRegion')}}: </span>
          <span v-if="selectedGeoRegion"><span class="text-weight-bold">{{ geoRegionsFlat[selectedGeoRegion].Label }} </span></span>
        </span>
        <span v-if="byProduct">
          <span>{{$t('global.GeoRegions')}}: </span>
          <span v-for="p in tickedRegion" :key="p">
                <span class="text-weight-bold">{{geoRegionsProductFlat[p].Label}} </span>
          </span>
        </span>
        <span v-if="selectedWork"> {{$t('global.Work')}}: <span class="text-weight-bold">{{ workTreeFlat[selectedWork].Label }} </span>
        </span> 
        {{$t('global.People')}}: <span class="text-weight-bold">{{ personlist }}</span>
        {{$t('global.Product')}}: <span class="text-weight-bold" v-if="$refs['selProducts']" >{{ $refs["selProducts"].actualValue }} </span> 
        <div  v-if="this.insertReady">
            <q-input v-model="comment" type="textarea" :stack-label="$t('global.Comment')" />
            <q-btn class="confirm" color="primary" v-on:click="sendRequest" :disable="comment == ''" >{{$t('Save')}}</q-btn>
        </div>
      </div>
    </q-card-title>
    <q-card-separator />
    <div class="row">
      <div class="col-xs-12 col-sm-4 content">
        {{$t('global.GeoRegion')}}
        <div v-show="byProduct">
          <q-tree 
            :nodes="geoRegionsProduct" 
            node-key="Id"
            :expanded.sync="propsExpandedProduct"
            :tick-strategy="tickStrategy" 
            :ticked.sync="tickedRegion"
          />
        </div>
        <div v-show="!byProduct">
          <q-tree 
            :nodes="geoRegions" 
            node-key="IdGeoRegion"
            :selected.sync="selectedGeoRegion"
            :expanded.sync="propsExpanded"
          />
        </div> 
      </div>
      <div class="col-xs-12 col-sm-4 content">
        {{$t('global.Work')}}
        <q-tree
          :nodes="workTree" 
          node-key="IdResource"
          :selected.sync="selectedWork"
          :expanded.sync="propsExpandedWork"
        />
      </div>
      <div class="col-xs-12 col-sm-4 content">
       {{$t('global.People')}}
       <q-tree
        :nodes="persons"
        node-key="Id"
        :tick-strategy="tickStrategy" 
        :ticked.sync="tickedPerson"
      />
      </div>
    </div>
    </q-card>
</div>

</template>

<script>
import axios from 'axios'
import qs from 'qs'

import {eventBus} from '../../main'


export default {
  name: 'DistributeWork',
  data: function () {
    return {
      form: {
        SessionId: null,
        action: 'GeoRegionsTree',
        IdLanguage: 1
      },
      comment: '',
      selectedGeoRegion: null,
      selectedWork: null,
      selectedPerson: null,
      ticked: [],
      tickStrategy: 'leaf',
      propsExpanded: [],
      propsExpandedProduct: [],
      propsExpandedWork: [],
      geoRegions: [],
      geoRegionsProduct: [],

      workTree: [],
      geoRegionsFlat: [],
      geoRegionsProductFlat: [],
      workTreeFlat: [],
      personTreeFlat: [],
      persons: [],
      tickedPerson: [],
      tickedRegion: [],
      byProduct: false,
      idProduct: 0,
      optionsProduct: [{label: 'Product 1', value: 1 }, {label: 'Product 2', value: 2 }],
    }
  },
  methods: {
      loadGeoRegionsTree(){
      var self = this
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.IdProduct = this.idProduct

      if (this.idProduct == 0)
        this.form.action = "GeoRegionsTreeActive"
      else
        this.form.action = "GeoRegionsTreeProduct"
      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {      
          if(response.status == 200){ 
            if(response.data.length != 0){
              self.propsExpanded.push(response.data[0].IdGeoRegion) //Open expand first node
            }
            var xx = this.$refs["selProducts"]
            self.makeTreeFlat(response.data)
            self.geoRegions = response.data
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    loadGeoRegionsProductTree(){
      var self = this
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getProductTree"
      
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
            self.geoRegionsProduct = response.data
            self.makeProductTreeFlat(response.data)
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    loadResourceTree(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getResourceTree"
      this.form.OnlyWorkSelectable = true
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              //this.propsExpanded.push(response.data[0].IdGeoRegion) //Open expand first node
              this.workTree = response.data
              this.makeWorkTreeFlat(response.data)
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },

    loadPersonTree(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getPersonTree"
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              //this.propsExpanded.push(response.data[0].IdGeoRegion) //Open expand first node
              this.persons = response.data
              this.makePersonTreeFlat(response.data)
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },


    makeTreeFlat(elements){ 
      elements.forEach(element => {
        this.geoRegionsFlat[element.IdGeoRegion] = { IdGeoRegion: element.IdGeoRegion, Label: element.label }
        //recursive call:
        this.makeTreeFlat(element.children)
      })
    },
    makeProductTreeFlat(elements){ 
      
      elements.forEach(element => {
        this.geoRegionsProductFlat[element.Id] = { Label: element.label }
        //recursive call:
        if(element.children != null){
          this.makeProductTreeFlat(element.children)
        }
      })
    },
    makeWorkTreeFlat(elements){ 
      elements.forEach(element => {
        this.workTreeFlat[element.IdResource] = { Label: element.label }
        //recursive call:
        this.makeWorkTreeFlat(element.children)
      })
    },
    makePersonTreeFlat(elements){ 
      if(elements != null){
        elements.forEach(element => {
          if(element.IdUser != null){
            this.personTreeFlat[element.IdUser] = { Label: element.label }
          }
          //recursive call:
          this.makePersonTreeFlat(element.children)
        
        })
      }
    },
    sendRequest(){
      
      this.form.SessionId = this.$store.state.session.SessionId
      if(!this.byProduct){
        this.form.action = "insertWorkAssign"
        this.form.IdProduct = this.idProduct
        this.form.assignment = { IdGeoRegion: this.selectedGeoRegion, 
          IdResource: this.selectedWork, Comment: this.comment, 
          Person: this.tickedPerson }  
      }
      else{
        this.form.action = "insertWorkMulitipleAssign"
        this.form.assignment = { IdGeoRegions: this.tickedRegion, 
          IdResource: this.selectedWork, Comment: this.comment, 
          Person: this.tickedPerson }  
      }



      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.$q.notify({ message: this.$t('global.OrderDistributed'), type: 'positive' })
              eventBus.$emit('WorkAssignUpdate', null)
          }
          else{
              this.$q.notify('Something Wrong.')
          }
      })
      .catch(e => {
        this.$q.notify('Something Wrong.')
        console.log(e);
      })
    },
    loadProduct(){
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "getAllProduct"
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            console.log(response)
            if(response.status == 200){ 
              this.optionsProduct = [] 
              this.optionsProduct.push({ value: 0, label: this.$t('global.All') })
              response.data.forEach(product => {
                this.optionsProduct.push(product)
              })
            }
            else{
                this.$q.notify('Something Wrong.')
            }
        })
        .catch(e => {        
          this.$q.notify('Something Wrong.')      
          console.log(e);
        })
    },
  },
  created () {
    this.loadGeoRegionsTree()
    this.loadGeoRegionsProductTree()
    this.loadResourceTree()
    this.loadPersonTree()
    this.loadProduct()
    eventBus.$on('workDefineChange', (data) => {
      this.loadResourceTree()
    }),
    eventBus.$on('dataChange', (data) => {
      this.loadProduct()
    })
  },
  computed: {
    personlist: function () {
      if(this.tickedPerson.length == 0)
        return this.$t('global.All')
        var personList = ''
        this.tickedPerson.forEach(element => {
          if (personList.length != 0)
            personList += ', '

          personList += this.personTreeFlat[element].Label 
      })
      return personList
    },
    insertReady: function () {
      if(this.selectedWork){
        if(this.byProduct){
          if(this.tickedRegion.length){
            return true
          }
        }
        else{
          if(this.selectedGeoRegion){
            return true
          }
        }
      }
      return false
    }
  },
    watch: {
    idProduct: function (newValue, oldValue) {
      //alert('reload geo tree')
      this.loadGeoRegionsTree()
      this.selectedGeoRegion = null
    }
  },
}
function round(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}
</script>
<style scoped>
.content{
  padding: 10px;
}
.titel{
  text-align: center;
}
.confirm{
  margin-top: 10px
}
</style>